import { useState, useEffect } from "react";

export default function StickyQuoteButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleQuote = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      className="fixed z-50 flex flex-col gap-3 transition-all duration-500"
      style={{
        bottom: "32px",
        right: "28px",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0) scale(1)" : "translateY(16px) scale(0.95)",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      {/* WhatsApp button — green */}
      <a
        href="https://wa.me/8613522126700"
        target="_blank"
        rel="nofollow noreferrer"
        className="flex items-center gap-2 cursor-pointer whitespace-nowrap transition-all duration-200 hover:brightness-110 active:scale-95"
        style={{
          background: "linear-gradient(135deg, #25D366 0%, #1ebe5d 100%)",
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "11px",
          letterSpacing: "0.12em",
          padding: "13px 20px",
          borderRadius: "50px",
          boxShadow: "0 4px 20px rgba(37,211,102,0.4), 0 2px 8px rgba(0,0,0,0.12)",
          textDecoration: "none",
        }}
      >
        <i className="ri-whatsapp-line text-base" />
        <span>WhatsApp: +86 13522126700 (Text Only)</span>
      </a>

      {/* Request Quote button — amber gold */}
      <button
        onClick={handleQuote}
        className="flex items-center gap-2 cursor-pointer whitespace-nowrap transition-all duration-200 hover:brightness-110 active:scale-95"
        style={{
          background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "11px",
          letterSpacing: "0.14em",
          padding: "13px 20px",
          borderRadius: "50px",
          border: "none",
          boxShadow: "0 4px 24px rgba(217,119,6,0.35), 0 2px 8px rgba(0,0,0,0.12)",
        }}
      >
        <i className="ri-mail-send-line text-sm" />
        REQUEST QUOTE
      </button>
    </div>
  );
}
